import {
   RouterProvider,
 } from "react-router-dom";

import BrowserRouter from './routes/routes';
import ErrorBoundary from './components/ErrorBoundary';
 
const App = () => {

    return (
        <ErrorBoundary>
            <RouterProvider router={BrowserRouter} />
        </ErrorBoundary>
    )

};
 
export default App;